import { Injectable, signal } from '@angular/core';

export interface ToasterConfig {
    message: string;
    status: 'success' | 'error' | 'warning' | 'info';
    duration?: number;
}

@Injectable({
    providedIn: 'root',
})
export class ToasterService {
    private readonly toastSignal = signal<ToasterConfig | null>(null);
    private readonly visibleSignal = signal(false);

    get toast() {
        return this.toastSignal;
    }

    get isVisible() {
        return this.visibleSignal;
    }

    show(config: ToasterConfig) {
        this.toastSignal.set(config);
        this.visibleSignal.set(true);

        // Auto hide after duration
        setTimeout(() => {
            this.hide();
        }, config.duration || 3000);
    }

    hide() {
        this.visibleSignal.set(false);
        setTimeout(() => {
            this.toastSignal.set(null);
        }, 300); // Wait for animation to complete
    }
}
